
/**
 * Created by lotuslwb1 on 15/10/19.
 */
function cpCompanyHandel() {
    this._init();
}

cpCompanyHandel.prototype = {
    _init: function () {
        this._bindEvent();
        this._getId();
    },
    _bindEvent: function () {
        var me = this;


    },
    _getId: function () {
        var me = this;
        var urlp = new window.mGG.urlParam();

        me.type = urlp.type || 2;
        me.mailNo = urlp.mailNo;
        me.cpCode = urlp.cpCode;

        var cptype = me.type == 3 ? 'outerkd' : 'innerkd'
        var api = window.mGG.api.getAppLogisticsCompanyInfo;
        var params = {
            'cptype': cptype,
            'version': 0,
            'srcfrom': 'guoguowap'
        }
        window.mGG.load(api, params, function (data) {
            var Innerdata = data.data.hot;
            var allCompany = data.data.company;
            var alphaData = data.data.alpha;
            var returnData = [];

            for (var i = 0; i < Innerdata.length; i++) {
                var code = Innerdata[i];
                var data = {
                    'companyName': allCompany[code].companyName || '',
                    'logo': allCompany[code].iconUrl100x100 || '//gw.alicdn.com/tps/TB1OKFWIFXXXXXyXpXXXXXXXXXX.png',
                    'cpCode': allCompany[code].companyCode || '',
                    'serviceTel': allCompany[code].serviceTel || ''
                }
                returnData.push(data);
            }

            me.hotData = returnData;
            me.alphaData = alphaData;
            me.allCompany = allCompany;
            me._loadcpList(me);
        });


    },
    _loadcpList: function (me) {
        var mailNo = me.mailNo || '';
        var cpCode = me.cpCode || '';
        var type = me.type;

        // console.log(me)

        //物流详情 选择快递公司
        if (type == 1) {
            if (!me.mailNo.length) {
                alert('缺少参数');
            } else {
                loadWithTpl('cplistTplNotel');
                $('.J-title-txt').text('选择快递公司');
            }
        }
        //国内快递 选择快递公司
        if (type == 2) {
            loadWithTpl('cplistTplNotel2');
            $('.J-title-txt').text('国内快递');
            window.onload = function () {
                goldlog.record('/cn.17.23.7','','','H46747619')
            };
        }

        //国外快递 选择快递公司
        if (type == 3) {
            loadWithTpl('cplistTplNotel2');
            $('.J-title-txt').text('国外快递');
            window.onload = function () {
                goldlog.record('/cn.17.23.8','','','H46747620')
            };
        }
        //国内快递电话
        if (type == 10) {
            loadWithTpl('cplistTpl');
            $('.J-title-txt').text('快递电话');
            window.onload = function () {
                goldlog.record('/cn.17.23.6','','','H46747618')
            };

        }

        function loadWithTpl(tpl) {

            var hotList = {
                'type': type,
                'cpCode': cpCode,
                'mailNo': mailNo,
                'data': me.hotData
            }
            var html = window.mGG.fillTpl(tpl, hotList);
            $('.J-rlist').html(html);

            var alphaData = [];
            var allCompany = me.allCompany;
            for (var key in me.alphaData) {
                for (var i = 0; i < me.alphaData[key].length; i++) {
                    var code = me.alphaData[key][i];
                    var data = {
                        'companyName': allCompany[code].companyName || '',
                        'logo': allCompany[code].iconUrl100x100 || '//gw.alicdn.com/tps/TB1OKFWIFXXXXXyXpXXXXXXXXXX.png',
                        'cpCode': allCompany[code].companyCode || '',
                        'serviceTel': allCompany[code].serviceTel || ''
                    }
                    alphaData.push(data);
                }
            }
            var allList = {
                'type': type,
                'cpCode': cpCode,
                'mailNo': mailNo,
                'data': alphaData
            }
            var html = window.mGG.fillTpl(tpl, allList);
            $('.J-alllist').html(html);

        }

    }
};

new cpCompanyHandel();





//////////////////
// WEBPACK FOOTER
// ./src/js/cpCompany.js
// module id = 0
// module chunks = 3